import {
  db,
  listenerCleanCache,
  pararListenerCleanCache,
} from "@/service/firebase";
import {
  deveAdiarManutencao,
  encerrarSessaoCompraParaManutencao,
} from "@/service/purchaseSession";
import { doc, onSnapshot } from "firebase/firestore";
import {
  manutencaoEfetiva,
  podeLiberarManutencao,
  preservarConfiguracaoOperacional,
} from "@/service/totemOperation";

const ROTA_HOME = "/cabine/home";
const ROTA_MANUTENCAO = "/manutencao";

let totemAssinado = null;
let cancelarListener = null;

function navegar(router, destino) {
  if (!router || router.currentRoute?.path === destino) return;

  const navegacao = router.replace(destino);
  if (navegacao && typeof navegacao.catch === "function") {
    navegacao.catch((erro) => {
      if (erro?.name !== "NavigationDuplicated") {
        // eslint-disable-next-line no-console
        console.error("Falha ao aplicar estado de manutenção do totem:", erro);
      }
    });
  }
}

function aplicarSnapshot(snapshot, store, router) {
  if (!snapshot.exists()) return;

  const payload = snapshot.data();
  if (!payload || typeof payload !== "object") return;

  // Snapshot incompleto não apaga uma manutenção nem torna disponível um
  // formato antes bloqueado. Uma liberação publica seus booleanos explícitos.
  const payloadEfetivo = preservarConfiguracaoOperacional(
    payload,
    store.getters?.["totem/getTotem"]
  );

  store.commit("totem/setTotem", payloadEfetivo);

  if (manutencaoEfetiva(payloadEfetivo)) {
    // O estado efetivo continua no store: o router aplicará a manutenção no retorno à
    // Home. Não desmontar pagamento/ impressão nem limpar esta compra agora.
    if (deveAdiarManutencao(store, router.currentRoute?.path)) return;
    // A decisão operacional é encerrar a sessão local: remove a escuta e
    // invalida callbacks já enfileirados antes de limpar a compra do Vuex.
    // Nenhuma etapa financeira é escrita implicitamente no documento remoto.
    encerrarSessaoCompraParaManutencao(store);
    navegar(router, ROTA_MANUTENCAO);
    return;
  }

  // Sair da manutenção sempre volta à Home. Em qualquer outra rota, uma
  // atualização comum do documento não interrompe a compra em andamento. A
  // saída exige false explícito; campo ausente não libera o equipamento.
  if (
    payload.config?.manutencao === false &&
    podeLiberarManutencao(payloadEfetivo) &&
    router.currentRoute?.path === ROTA_MANUTENCAO
  ) {
    navegar(router, ROTA_HOME);
  }
}

export function pararListenerTotemEmTempoReal() {
  const cancelar = cancelarListener;
  cancelarListener = null;
  totemAssinado = null;
  if (typeof cancelar === "function") cancelar();
  pararListenerCleanCache();
}

export function iniciarListenerTotemEmTempoReal(totemId, { store, router }) {
  const id = String(totemId || "").trim();
  if (!id || !store || !router) return null;

  // O init pode ser reexecutado pela recuperação do kiosk. Não cria uma
  // segunda assinatura quando a identidade continua sendo a mesma.
  if (totemAssinado === id && cancelarListener) return cancelarListener;

  pararListenerTotemEmTempoReal();
  totemAssinado = id;

  // O comando RTDB clean_cache também é singleton por ID. Ele permanece
  // separado da manutenção, mas passa a sobreviver às trocas de tela junto do
  // listener global do documento do totem.
  Promise.resolve(listenerCleanCache(id)).catch((erro) => {
    // eslint-disable-next-line no-console
    console.error("Falha ao iniciar listener de limpeza de cache:", erro);
  });

  const referencia = doc(db, "totem", id);
  try {
    cancelarListener = onSnapshot(
      referencia,
      (snapshot) => aplicarSnapshot(snapshot, store, router),
      (erro) => {
        // O SDK mantém a reconexão em falhas transitórias. O callback de erro
        // registra recusas terminais sem criar polling paralelo.
        // eslint-disable-next-line no-console
        console.error(`Listener do totem ${id} interrompido:`, erro);
      }
    );
  } catch (erro) {
    totemAssinado = null;
    cancelarListener = null;
    pararListenerCleanCache();
    throw erro;
  }

  return cancelarListener;
}
